import { configureStore} from '@reduxjs/toolkit';
import  {thunk}  from 'redux-thunk';
import purchaseresucer from './PurchaseSlice';
import Expirereducer from './ExpiredSlice';
import LabserviceReducer from './LabservicesSlice';
import LoginReducer from './LoginSlice';
import Addpatientreducer from './AddpatientSlice';
import AdduserReducer from './AddusersSlice';
import EditprofileReducer from './EditProfileSlice';
import AddservicesReducer from './AddservicesSlice';
import AddpackageReducer from './AddpackageSlice';
import ResultReducer from './ResultSlice';
import AdddepatmentReducer from './Department/AddDepartmentSlice';
import AddDoctorReducer from './Doctor/AddDoctorSlice';
import DiagnosisReducer from './DoctorFrame/DiagnosisSlice';
import SignupReducer from './SignupSlice';
import LoggedpatientReducer from './PatientFrame/LoggedPatientSlice';
import AddfloorReducer from './AddfloorSlice';
import ProfileReducer from "./ProfileSlice";
import newPatientReducer from './NewPatientSlice';
import PharmacydetailsReducer from './PharmacydetailsSlice';
import LoadingReducer from './LoadingSlice';
import MonitoringReducer from './Monitoring';
import SearchNavReducer from './NurseFrame/SearchNavSlice';
import MedicinemasterReducer from './MedicineMasterSlice';
import PrescriptionReducer from './PrescriptionSlice';
import ErrorReducer from './ErrorSlice';
import DashboardReducer from './DashboardSlice';
import TemplateReducer from './AddTemplate';
import VedioconferenceReducer from './DoctorFrame/Vedioconference'
import InvoiceReducer from './InvoicesSlice'
import AssignRoleReducer from './AssignRoleSlice';
import OpenAiReducer from './OpenAiSlice';
import OpenClaudeAISlice from './OpenClaudeAISlice';
import PatientconsultationReducer from './PatientFrame/Bookconsultation'
import KycDetailsReducer from './DoctorFrame/KycDetailSlice'
import doctorReducer from './doctorReducer';
import appointmentReducer from './appointmentReducer';
import consultationReducer from './ConsultationSlice'
import doctorUpdatesReducer from './doctorUpdatesSlice';
import loginReducer from './LogSlice'
import outpatientReducer from './outpatientSlice';
import kycReducer from './kycSlice';
import AdmingBookingReducer from './AdminBookingSlice'
import paymentMethodsReducer from './paymentMethodsSlice';
import manageRoomsReducer from './manageRoomsSlice'
import inpatientchartReducer from './inpatientchartSlice'
import departmentsReducer from './departmentsSlice'
import pharmacyReducer from './pharmacySlice'
import templateReducer from './templateSlice'
import managekycReducer from './manageKycSlice'
import HrDoctorsReducer from './HrdoctorsSlice'
import HrDoctorKycReducer from './hrKycSlice'
import LabTechReducer from './labtechSlice'
import LabTestUpdateReducer from './labTestUpdatesSlice'
import labTestReducer from './labTestSlice'
import patientSearchReducer from './patientSearchSlice';
import reportsReducer from './reportsSlice'
import admindashReducer from './admindashSlice'
import bloodBankReducer from './bloodBankSlice'
import surgeryScheduleReducer from './surgeryScheduleSlice';
import secretaryReducer from './secretarySlice'
import secretaryConsultationReducer from './secretaryConsultationSlice'
import patientReportsReducer from './patientReportsSlice'
import medicineMasterReducer from './Slices/medicineMasterSlice';
import pharmacyPurchaseReducer from './Slices/pharmacyPurchaseSlice';
import medicineInventoryReducer from './Slices/medicineInventorySlice'
import financialReducer from './Slices/financialSlice'
import foodServiceReducer from './Slices/foodServiceSlice';
import insuranceReducer from './Slices/insuranceSlice';
import patientsTreatedReducer from './Slices/PatientsTreatedSlice'
import documentReducer from './Slices/documentSlice'
export default configureStore({
    reducer: {
        signup:SignupReducer,
        login: loginReducer,
        // purchase section
        purchase:purchaseresucer,
        expired:Expirereducer,
        labsevicesdetails:LabserviceReducer,
        logindetails:LoginReducer,
        Addpatentdetails:Addpatientreducer,
        Addusers:AdduserReducer,
        Editprofile:EditprofileReducer,
        Addservices:AddservicesReducer,
        Addpackages:AddpackageReducer,
        Results:ResultReducer,
        Addfloor:AddfloorReducer,
        Profiledata:ProfileReducer,
        newPatient:newPatientReducer,
        PharmacyDetails:PharmacydetailsReducer,
        MonitorPatient:MonitoringReducer,
        Medicinemaster:MedicinemasterReducer,
        Prescription:PrescriptionReducer,
        Errorhandle:ErrorReducer,
        Dashboard:DashboardReducer,
        Template:TemplateReducer,
        Invoice:InvoiceReducer,
        // departments
        Adddepartment:AdddepatmentReducer,
        //doctors
        Adddoctor:AddDoctorReducer,

        //doctorframe
        DiagnosePatient:DiagnosisReducer,
        Vedioconference:VedioconferenceReducer,
        KycDetails:KycDetailsReducer,
        kyc: kycReducer,

        // patientframe
        Loggedpatient:LoggedpatientReducer,
        Assignrole:AssignRoleReducer,
        loading:LoadingReducer, 
        OpenAI:OpenAiReducer,
        ClaudeAI:OpenClaudeAISlice,
        Bookconsultation:PatientconsultationReducer,

        //nurseframe
        SearchNurse:SearchNavReducer,
        //admindash
        doctorsState: doctorReducer,
        appointment: appointmentReducer,
        consultation: consultationReducer,
        doctorUpdates: doctorUpdatesReducer,
        outpatient: outpatientReducer,
        adminBooking:AdmingBookingReducer,
        paymentMethods: paymentMethodsReducer,
        manageRooms: manageRoomsReducer,
        inpatientchart: inpatientchartReducer,
        departments: departmentsReducer,
        pharmacy: pharmacyReducer,
        templates: templateReducer, 
        managependingkyc:managekycReducer,
        hrdoctors:HrDoctorsReducer,
        managehrkyc:HrDoctorKycReducer,
        labtech:LabTechReducer,
        labTestUpdates:LabTestUpdateReducer,
        labTests: labTestReducer,
        patientSearch: patientSearchReducer,
        reports:reportsReducer,
        admindash:admindashReducer,
        bloodBank: bloodBankReducer,
        surgerySchedule: surgeryScheduleReducer,
        secretary: secretaryReducer,
        secretaryConsultation: secretaryConsultationReducer,
    patientReports: patientReportsReducer,

 medicineInventory: medicineInventoryReducer,
    medicineMaster: medicineMasterReducer,
    pharmacyPurchase: pharmacyPurchaseReducer,
    financial: financialReducer,
    foodService: foodServiceReducer,
        insurance: insuranceReducer,
    patientsTreated: patientsTreatedReducer,
        documents: documentReducer,


    },
    
    middleware:[thunk]
});

